let turnstileLoaded = false;

document.addEventListener('DOMContentLoaded', function(){
  if(turnstileLoaded || typeof turnstile === 'undefined'){
    return;
  }

  turnstileLoaded = true;

  document.querySelectorAll('.cp-turnstile').forEach((item) => {
    const widget_id = turnstile.render(item, {
      sitekey: clover_turnstile.sitekey,
      'response-field-name': clover_turnstile.fieldname,
      appearance: 'interaction-only'
    });

    ['wpcf7invalid', 'wpcf7spam', 'wpcf7mailfailed'].forEach(function(e) {
      document.addEventListener(e, function (event) {
        if(typeof turnstile !== 'undefined'){
          try{
            turnstile.reset(widget_id);
          }catch(e){}
        }
      });
    });
  });
});
